import React from "react";
import { withRouter } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

class MenuExtraescolares extends React.Component {
  handleOpcionInicio = () => this.props.history.push("/extraescolares/inicio");
  handleOpcionListados = () =>
    this.props.history.push("/extraescolares/listados");

  render() {
    return (
      <Dropdown item simple text="Extraescolares">
        <Dropdown.Menu>
          <Dropdown.Item content="General" onClick={this.handleOpcionInicio} />
          <Dropdown.Item
            content="Listados"
            onClick={this.handleOpcionListados}
          />
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default withRouter(MenuExtraescolares);



// WEBPACK FOOTER //
// ./src/pages/appLayout/menuSuperior/MenuExtraescolares.jsx